<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">Link Sample Margin to Job</div>
    <div class="nova__dialog__toolbar__controls">
        <button class="nova__button--icon" [mat-dialog-close]="false">
            <mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon>
        </button>
    </div>
</div>
<div mat-dialog-content class="nova__dialog__content">
    <div flex="100" layout-row>
        <div layout-column flex="100" layout-align="space-around" md-padding style="margin: 24px">
            <mat-form-field flex="100" class="nova__input--fill" style="min-width: 300px">
                <mat-label>Sample margin id</mat-label>
                <input matInput type="number" name="sampleMarginId" [(ngModel)]="sampleMarginId">
            </mat-form-field>
        </div>
    </div>

    <mat-dialog-actions class="nova__dialog__content__actions">
        <button mat-raised-button color="primary" [disabled]="saved || !sampleMarginId" (click)="save()">
            Save
        </button>
        <button mat-raised-button color="default" [mat-dialog-close]="false">
            Cancel
        </button>
    </mat-dialog-actions>
</div>
